function findVideos() {
    const videos = document.querySelectorAll('.b-video');

    for (let i = 0; i < videos.length; i++) {
        setupVideo(videos[i]);
    }
}

function setupVideo(video) {
    const link = video.querySelector('.b-video__link');
    const media = video.querySelector('.b-video__media');
    const button = video.querySelector('.b-video__btn');
    const id = parseMediaURL(media);

    video.addEventListener('click', () => {
        let iframe = createIframe(id);

        link.remove();
        button.remove();
        video.appendChild(iframe);
    });

    link.removeAttribute('href');
    video.classList.add('b-video_enabled');
}

function parseMediaURL(media) {
    const regexp = /https:\/\/i\.ytimg\.com\/vi\/([a-zA-Z0-9_-]+)\/maxresdefault\.jpg/i;
    const url = media.src;
    const match = url.match(regexp);

    return match[1];
}

function createIframe(id) {
    const iframe = document.createElement('iframe');

    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay');
    iframe.setAttribute('src', generateURL(id));
    iframe.classList.add('b-video__media');

    return iframe;
}

function generateURL(id) {
    return `https://www.youtube.com/embed/${id}?rel=0&showinfo=0&autoplay=1`;
}

document.addEventListener("DOMContentLoaded", findVideos);
